// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { quickRfqFromStyles } from "@awc/App/Widgets/CustomForms/QuickRfqFrom";
import { css } from "styled-components";

quickRfqFromStyles.inputsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 10px;
    `,
};

quickRfqFromStyles.formWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
};

quickRfqFromStyles.fileUpload = {
    css: css`
        > div {
            display: flex;
            flex-direction: column;
        }
        .mobiusFileUpload {
            padding: 0 8px !important;
        }
        .mobiusFileVisual {
            max-width: calc(100% - 60px) !important;
            padding-right: 0 !important;
        }
    `,
};

quickRfqFromStyles.title = {
    variant: "h2",
};

quickRfqFromStyles.subTitle = {
    forwardAs: "p",
    css: css`
        margin-bottom: 16px;
    `,
};

quickRfqFromStyles.submitButton = {
    variant: "tertiary",
    css: css`
        width: auto;
        margin-left: auto;
        margin-top: 20px;
    `,
};
